var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBackward = function SvgBackward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#231727",
    d: "M1.59 13.582a2 2 0 0 0-.008 2.828l12.692 12.764a2 2 0 0 0 2.836-2.82L5.83 15.007 17.174 3.726A2 2 0 0 0 14.354.89zm33.416-.492-32-.09-.011 4 32 .09z"
  })));
};
export default SvgBackward;